import styled, { css } from 'styled-components';

const borderCss = ({ border }) =>
  !!border &&
  css`
    &:after {
      content: '';
      width: 2px;
      background: var(--grey200);
      height: 20px;
      display: inline-block;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
    }
  `;

export default styled.div`
  flex: 1 0 40%;
  padding-left: 8px;
  overflow: hidden;
  position: relative;

  ${borderCss}
`;
